export default "<p>\n  icon-adapter works!\n</p>\n"